import { useTheme } from "@mui/material/styles";

import MuiCard, { type CardProps } from "@mui/material/Card";
import MuiCardActions from "@mui/material/CardActions";
import MuiCardHeader from "@mui/material/CardHeader";
import MuiCardContent, { type CardContentProps } from "@mui/material/CardContent";


Card.Actions = MuiCardActions;

Card.Box = (props: CardProps) => {
	const theme = useTheme();
	const style = {
		root: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: 1.25,
			p: 2,
			borderRadius: 2,
			border: "1px solid",
			borderColor: theme.palette.border.default
		}
	};

	return <Card {...props} sx={{ ...style.root, ...props.sx }} />;
};

Card.Header = MuiCardHeader;

Card.Content = (props: CardContentProps) => {
	const style = {
		root: {
			display: "flex",
			flexDirection: "column",
			gap: 2,
			...props.sx
		}
	} as SxProps;

	return <MuiCardContent {...props} sx={style.root} />;
};

export default function Card(props: CardProps) {
	const style = {
		root: {
			borderRadius: "12px"
		}
	};
	return <MuiCard {...props} sx={{ ...style.root, ...props.sx }} />;
}